<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      resizeFn: null,
    };
  },
  mounted() {
    this.resize();
    window.onresize = function () {
      this.resize();
    }.bind(this);
  },
  methods: {
    resize() {
      let cliWidth =
        document.documentElement.clientWidth || document.body.clientWidth;
      let cliHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      let contW = 1920;
      let contH = 1080;
      let w = cliWidth / contW;
      let h = cliHeight / contH;
      let appDom = document.querySelector("#app");
      appDom.style.transform = `scale(${w}, ${h})`;
      appDom.style.transformOrigin = "top left";
      appDom.style.width = contW + "px";
      appDom.style.height = contH + "px";
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize);
  },
};
</script>

<style>
@font-face {
  font-family: YouSheBiaoTiHei;
  src: url("./assets/font/YouSheBiaoTiHei-2.ttf");
}

html,
body {
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding: 0;
  margin: 0;
}

html {
  font-size: 20px;
}

body {
  transform-origin: left top;
  background-size: 100% 100%;
}

#app {
  /* background: url('./assets/bg.png') no-repeat center center / 100% 100%; */
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

/* ::-webkit-scrollbar {
  display: none;
} */

.uploadBox .el-button {
  background-color: RGBA(21, 66, 140, 1);
  border-color: RGBA(13, 19, 37, 1);
  color: #fff;
}

.uploadBox .el-button:not(.is-text):focus,
.uploadBox .el-button:not(.is-text):hover {
  color: #fff;
  border-color: var(--el-button-hover-border-color);
  background-color: RGBA(13, 19, 37, 1);
  outline: 0;
}

::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
  background: #053a95c5;
}

::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
  border-radius: 10px;
  background: #ededed6d;
}
</style>
